<template>
    <span class="tw:flex">
        <i v-for="rating in [1, 2, 3, 4, 5]" v-bind:key="rating" class="fa tw:text-yellow-500" v-bind:class="{
            'fa-star' : (props.ratingValue >= rating),
            'fa-star-half-o':( (Math.round(props.ratingValue) === rating) && (props.ratingValue < rating) ),
            'fa-star-o' : ( (props.ratingValue < rating) && (Math.round(props.ratingValue)  < rating))
        }"></i>
    </span>
</template>
<script setup>
const props = defineProps({
  ratingValue: {
    type: Number,
    default: 0
  }
})
</script>
